"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.ResetButton = exports.FilterElement = exports.StyledFilterSelections = exports.CancelButton = exports.ApplyButton = exports.StyledPopover = exports.PaddedCheckboxGroup = exports.PaddedRadioGroup = exports.FilterInputHeader = exports.FilterInputFooter = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.FilterInputFooter = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  border-top: 1px solid ", ";\n  padding: ", ";\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  border-top: 1px solid ", ";\n  padding: ", ";\n  justify-content: flex-end;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
exports.FilterInputHeader = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  padding: ", ";\n  border-bottom: 1px solid ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.mercury;
});
exports.PaddedRadioGroup = (0, styled_components_1.default)(storm_ui_1.RadioGroup)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", ";\n  text-align: left;\n"], ["\n  padding: ", ";\n  text-align: left;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
exports.PaddedCheckboxGroup = (0, styled_components_1.default)(storm_ui_1.CheckboxGroup)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: ", ";\n  text-align: left;\n"], ["\n  padding: ", ";\n  text-align: left;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
exports.StyledPopover = (0, styled_components_1.default)(storm_ui_1.Popover)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  width: 320px;\n"], ["\n  width: 320px;\n"])));
exports.ApplyButton = (0, styled_components_1.default)(storm_ui_1.Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 80px;\n  margin: 0 5px;\n"], ["\n  width: 80px;\n  margin: 0 5px;\n"])));
exports.CancelButton = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin: 0 5px;\n"], ["\n  margin: 0 5px;\n"])));
exports.StyledFilterSelections = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  border-bottom: none;\n  padding: ", ";\n  background-color: ", ";\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  border-bottom: none;\n  padding: ", ";\n  background-color: ", ";\n  flex-wrap: wrap;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.concrete;
});
exports.FilterElement = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.micro;
});
exports.ResetButton = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
exports.StyledIcon = (0, styled_components_1.default)(storm_ui_1.Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  color: ", ";\n  margin-inline-start: ", ";\n"], ["\n  color: ", ";\n  margin-inline-start: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.boulder;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.small;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
